import script from "./dxxds.vue?vue&type=script&setup=true&lang=js"
export * from "./dxxds.vue?vue&type=script&setup=true&lang=js"

import "./dxxds.vue?vue&type=style&index=0&id=e5994c9e&lang=less"

const __exports__ = script;

export default __exports__